export default __webpack_public_path__ + "static/case-study-tablet-9d75a2da95b5240f0da3b183f709538a.png";